<template>
<div>
     <div style="position:fixed;top:0;left:0;z-index:100;" class="yt_title">
        {{title}}
        <a href="/"> <img class="yl_home" src="../assets/shouye.png" alt=""></a>
    </div>
    <div class="tl_ul">
        <van-list
  v-model="loading"
  :finished="finished"
  finished-text="没有更多了"
  @load="onLoad"
  :error.sync="error"
>
  <van-cell
    v-for="item in list"
    :key="item.tid"
  >
    <a :href="item.biaoqian=='专题' ? item.Url : '/#/detail/'+item.tid">
    <div  class="tl_li">
        <div>
            <img v-if="item.pic?true:false" :src="item.pic" :alt="item.title">
            <div :class="item.pic?'marleft':''">
                <h1>{{item.title}}</h1>
                <p>{{item.PublishTime|TimeData}}</p>
            </div>
        </div>
    </div>
      </a>
  </van-cell>
</van-list>
    </div>
</div>
</template>

<script>
import {Dialog} from 'vant'
export default {
     data() {
        return {
            list: [],
            loading: false,
            finished: false,
            page:1,
            error:false,
            title:'',
            org_id:0
        };
    },
    methods:{
        toLinks(){
            this.osUrl();
        },
        toHome(){
            this.$router.push('/')
        },
        onLoad(){
            this.$http.get(this.baseUrl+'/v1/news/lists?appid='+this.appid+"&classid="+this.$route.params.id+'&page='+this.page)
        .then(res=>{
            if(res.data.statecode==1){
                if(res.data.data.data.length>0){
                    this.list = this.list.concat(res.data.data.data)
                    this.loading = false;
                    this.page = this.page+1;
                }else{
                    this.loading = false;
                    this.finished =true;
                }
            }else{
                this.loading = false;
                this.error = true;
                Dialog.alert({
                    message:res.data.message
                }).then((rr)=>{
                    this.toHome()
                })
            }
        })
        .catch(err=>{
            Dialog.alert({
                    message:err
            }).then((rr)=>{
                    this.toHome()
            })
        })
        },
    },
    filters:{
        TimeData:function(timestamp) {
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y+M+D+h+m+s;
        }
    },
    mounted(){
        this.appid = localStorage.getItem('appid')
        this.org_id = localStorage.getItem('org_id')
        var webname = localStorage.getItem('webname')
        if(this.$route.params.id==undefined){
          Dialog.alert({message:"分类id不能为空"}).then((rr)=>{
                this.toHome();
              })
        }
        if(!this.appid){
            this.$http.get(this.baseUrl+'/v1/app/site?appid='+this.appid+"&url="+window.location.host).then((res)=>{
              if(res.data.statecode==1){
                if(res.data.data.app_id!=undefined){
                   webname = res.data.data.webname;
                   var appid = res.data.data.app_id;
                   var logo = res.data.data.logo;
                   this.org_id = res.data.data.org_id;
                   this.appid = appid;
                   localStorage.setItem("webname",webname);
                   localStorage.setItem("appid",appid);
                   localStorage.setItem("logo",logo);
                   localStorage.setItem("org_id",this.org_id);
                }else{
                  Dialog.alert({message:"appid不存在"})
                }
              }else{
              Dialog.alert({message:res.data.message})
            }
          })
        }
        this.$http.get(this.baseUrl+'/v1/news/cate?appid='+this.appid+'&classid='+this.$route.params.id).then((rr)=>{
            if(rr.data.statecode==1){
                this.title = rr.data.data.class_name
                document.title = this.title+"-"+document.title+'-'+webname
                // var _paq = window._paq = window._paq || [];
                // /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
                // _paq.push(['setCustomVariable', 1, "channel_id", "WAP", "page"]);
                // _paq.push(['setCustomVariable', 2, "screen", "news_list", "page"]);
                // _paq.push(['setCustomVariable', 4, "class_id", this.$route.params.id, "page"]);
                // _paq.push(['trackPageView']);
                // _paq.push(['enableLinkTracking']);
                // var org_id = this.org_id;
                // (function() {
                //     var u="https://click-xhncloud.voc.com.cn/";
                //     _paq.push(['setTrackerUrl', u+'matomo.php']);
                //     _paq.push(['setSiteId', org_id]);
                //     var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                //     g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
                // })();
          }else{
            Dialog.alert({message:rr.data.message}).then(()=>{
              this.toHome();
            })
          }
        })


    }

}
</script>

<style scoped>
    *{
        box-sizing: border-box;
    }
    .yt_title{
        width: 100%;
        height:110px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        font-size: 46px;
        color: #fff;
        background-color:#e80214;
        text-align: center;
        line-height: 46px;
    }
    .yt_title>a .yl_home{
        width: 38px;
        height: 39px;
        position: absolute;
        top: 50%;
        margin-top: -18.5px;
        left: 36px;
    }
    .tl_ul{
        margin-top: 110px;
        margin-bottom: 50Px
    }
    .tl_li{
        width: 100%;
        padding: 0 36px;
    }
    .van-cell{
        padding: 0;
    }
    .tl_li>div{
        width: 100%;
        height: 205px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
    }
    .tl_li>div>img{
        width: 226px;
        height: 152px;
    }
    .tl_li>div>div{
        height: 152px;
        flex: 1;
    }
    .tl_li>div>.marleft{
        padding-left:39px;
    }
    .tl_li>div>div h1{
        font-size: 32px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin: 0;
    }
    .tl_li>div>div p{
        color: #888;
        font-size: 22px;
        margin: 0;
    }
    .nav_bottom{
	width: 100%;
	height: 50Px;
	background: #fff;
	position: fixed;
	left: 0;
	bottom: 0;
	z-index: 100;
	border-top: 1Px solid #eee;
	display: flex;
	align-items: center;
	box-shadow: 1px -3px 62px 0px 
		rgba(9, 1, 3, 0.15);
}
.nav_b_logo{
	height: 50Px;
	display: flex;
	align-items: center;
}
.nav_b_logo img{
	width: 35Px;
	margin: 0 10Px;
}
.open_btn{
	float: right;
	height: 30Px;
	line-height: 30Px;
	margin-right: 10Px;
}
</style>